<template>
  <div :class="['headline container-fluid bg-color', className]">
    <div class="wrapper-fluid">
      <div class="row">
        <div class="col-12 col-lg-10 col-xl-8">
          <h1 class="h1-xl header-gradient">Helping you Lead the Way in Industrial Solutions</h1>
        </div>
      </div>
    </div>
    <div class="wrapper-fixed">
      <div class="row justify-content-end">
        <div class="col-12 col-lg-8 mb-5 mb-lg-0">
          <p>At FCG Ecommerce Solutions, we empower our sister companies with creative, industry-leading eCommerce technology and digital marketing expertise. With deep knowledge of commercial and industrial products—especially in flow control and automation—and a powerful technology platform, we deliver smart, cost-effective solutions that drive growth and streamline operations.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockHeadline',
  props: {
    className: [String, Array], // Expecting a string of class names
  },
};
</script>